// @ts-nocheck
/* Starter Sync - BrandDetailsImage */

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { BrandStateContext } from "@insite/client-framework/Store/Data/Brands/BrandsSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import LazyImage, { LazyImageProps } from "@insite/mobius/LazyImage";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import constants from "@store/constants";
import LinkBack, { LinkBackPresentationProps } from "@store/Library/Components/Toolkit/LinkBack";
import OrderHeader from "@store/Library/Components/Toolkit/Order/OrderHeader";
import { brandProps } from "@store/Themes/common/props/brand";
import { linkGetActionLinkProps } from "@store/Themes/common/props/link";
import { usePageLinkByPageType } from "@toolkit/Framework/Store/Links/LinksHooks";
import { spacingStyles } from "@toolkit/Themes/common/mixins";
import React, { FC, useContext } from "react";

const enum fields {
    showLogo = "showLogo",
}

export interface BrandDetailsTitleProps extends WidgetProps {
    fields: {
        [fields.showLogo]: boolean;
    };
}

export interface BrandDetailsTitleStyles {
    linkBack?: LinkBackPresentationProps;
    imageWrapper?: InjectableCss;
    image?: LazyImageProps;
    externalLink?: LinkPresentationProps;
    productLink?: LinkPresentationProps;
}

export const brandDetailsTitleStyles: BrandDetailsTitleStyles = {
    imageWrapper: { css: spacingStyles() },
    image: brandProps.logoSmall,
    externalLink: linkGetActionLinkProps(),
    productLink: linkGetActionLinkProps(),
};

const styles = brandDetailsTitleStyles;

const BrandDetailsTitle: FC<BrandDetailsTitleProps> = ({ fields }) => {
    const { value: brand } = useContext(BrandStateContext);
    const brandListLink = usePageLinkByPageType(constants.pageType.brands);
    const { showLogo } = fields;

    if (!brand) {
        return null;
    }

    return (
        <>
            <LinkBack pageLink={brandListLink} {...styles.linkBack} />
            {showLogo && brand.logoSmallImagePath ? (
                <StyledWrapper {...styles.imageWrapper}>
                    <LazyImage
                        altText={brand.logoAltText || brand.name}
                        src={brand.logoSmallImagePath}
                        {...styles.image}
                    />
                </StyledWrapper>
            ) : null}
            <OrderHeader title={brand.name}>
                {brand.externalUrl && (
                    <Link
                        data-test-selector="brandExternalUrlLink"
                        href={brand.externalUrl}
                        {...styles.externalLink}
                        target="_blank"
                    >
                        {translate("Visit Website")}
                    </Link>
                )}
                <Link
                    data-test-selector="brandToProductPageLink"
                    href={brand.productListPagePath}
                    {...styles.productLink}
                >
                    {translate("Shop All Products")}
                </Link>
            </OrderHeader>
        </>
    );
};

const widgetModule: WidgetModule = {
    component: BrandDetailsTitle,
    definition: {
        group: "Brand Details",
        displayName: "Brand Title",
        allowedContexts: ["BrandDetailsPage"],
        fieldDefinitions: [
            {
                name: fields.showLogo,
                displayName: "Show Logo",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
            },
        ],
    },
};

export default widgetModule;
